export const categoryTabs = [
  { id: "all", name: "全部" },
  { id: "slots", name: "电子游艺" },
  { id: "live", name: "真人荷官" },
  { id: "sports", name: "体育竞技" },
  { id: "table", name: "棋牌桌游" },
  { id: "fishing", name: "捕鱼游戏" },
  { id: "jackpot", name: "累积奖池" },
];

export const categoryGames = [
  {
    id: 1,
    name: "金狮王座",
    category: "slots",
    image: "https://readdy.ai/api/search-image?query=Majestic%20golden%20lion%20slot%20machine%20game%20screen%20with%20royal%20crown%20and%20treasure%20theme%2C%20luxurious%20golden%20color%20palette%2C%20dark%20elegant%20background%2C%20gaming%20interface%20with%20sparkling%20effects%2C%20casino%20game%20art%2C%20rich%20amber%20and%20gold%20tones&width=600&height=400&seq=game-01&orientation=landscape",
    rating: 4.9,
    players: "128,500",
    tag: "热门",
    tagColor: "bg-accent-500",
  },
  {
    id: 2,
    name: "幸运777",
    category: "slots",
    image: "https://readdy.ai/api/search-image?query=Classic%20lucky%20777%20slot%20machine%20with%20vibrant%20red%20and%20golden%20reels%2C%20glowing%20neon%20numbers%2C%20casino%20floor%20background%20with%20bokeh%20lights%2C%20retro%20gaming%20style%2C%20warm%20golden%20illumination%2C%20high%20contrast%2C%20gaming%20artwork&width=600&height=400&seq=game-02&orientation=landscape",
    rating: 4.8,
    players: "95,200",
    tag: "经典",
    tagColor: "bg-primary-500",
  },
  {
    id: 3,
    name: "深海宝藏",
    category: "slots",
    image: "https://readdy.ai/api/search-image?query=Deep%20sea%20treasure%20slot%20game%20with%20golden%20chests%20and%20pearls%2C%20underwater%20theme%20with%20blue%20and%20gold%20colors%2C%20animated%20bubbles%2C%20mysterious%20ancient%20ruins%2C%20gaming%20interface%2C%20rich%20dark%20ocean%20background%2C%20digital%20art&width=600&height=400&seq=game-03&orientation=landscape",
    rating: 4.7,
    players: "76,800",
    tag: "新品",
    tagColor: "bg-secondary-500",
  },
  {
    id: 4,
    name: "百家乐豪华厅",
    category: "live",
    image: "https://readdy.ai/api/search-image?query=Luxurious%20baccarat%20table%20with%20professional%20dealer%20in%20formal%20dress%2C%20golden%20chandelier%20above%2C%20elegant%20dark%20wood%20interior%2C%20warm%20candle-like%20lighting%2C%20premium%20casino%20photography%2C%20rich%20amber%20tones%2C%20high%20detail&width=600&height=400&seq=game-04&orientation=landscape",
    rating: 4.9,
    players: "156,300",
    tag: "热门",
    tagColor: "bg-accent-500",
  },
  {
    id: 5,
    name: "轮盘至尊",
    category: "live",
    image: "https://readdy.ai/api/search-image?query=Elegant%20roulette%20wheel%20spinning%20with%20golden%20accents%2C%20professional%20croupier%20hand%2C%20dark%20green%20felt%20table%2C%20luxurious%20casino%20setting%20with%20warm%20lighting%2C%20dramatic%20focus%20on%20wheel%2C%20premium%20gaming%20photography&width=600&height=400&seq=game-05&orientation=landscape",
    rating: 4.8,
    players: "112,400",
    tag: "经典",
    tagColor: "bg-primary-500",
  },
  {
    id: 6,
    name: "龙虎斗",
    category: "live",
    image: "https://readdy.ai/api/search-image?query=Dragon%20versus%20tiger%20card%20game%20table%20with%20dramatic%20red%20and%20gold%20decor%2C%20Asian-themed%20casino%20interior%2C%20professional%20dealer%2C%20ornate%20golden%20details%2C%20warm%20intimate%20lighting%2C%20luxurious%20atmosphere%2C%20gaming%20photography&width=600&height=400&seq=game-06&orientation=landscape",
    rating: 4.7,
    players: "89,600",
    tag: "新品",
    tagColor: "bg-secondary-500",
  },
  {
    id: 7,
    name: "世界杯竞猜",
    category: "sports",
    image: "https://readdy.ai/api/search-image?query=Dynamic%20soccer%20match%20scene%20with%20players%20in%20action%20on%20green%20field%2C%20dramatic%20stadium%20lighting%2C%20golden%20trophy%20overlay%2C%20sports%20betting%20theme%2C%20cinematic%20sports%20photography%2C%20vibrant%20atmosphere%2C%20premium%20sports%20aesthetic&width=600&height=400&seq=game-07&orientation=landscape",
    rating: 4.9,
    players: "210,800",
    tag: "热门",
    tagColor: "bg-accent-500",
  },
  {
    id: 8,
    name: "NBA篮球",
    category: "sports",
    image: "https://readdy.ai/api/search-image?query=Intense%20basketball%20game%20with%20player%20dunking%2C%20dramatic%20arena%20lights%2C%20excited%20crowd%20silhouettes%2C%20sports%20betting%20theme%2C%20golden%20and%20amber%20color%20accents%2C%20cinematic%20sports%20photography%2C%20high%20energy%20atmosphere&width=600&height=400&seq=game-08&orientation=landscape",
    rating: 4.8,
    players: "178,500",
    tag: "经典",
    tagColor: "bg-primary-500",
  },
  {
    id: 9,
    name: "德州扑克大师",
    category: "table",
    image: "https://readdy.ai/api/search-image?query=Professional%20Texas%20Holdem%20poker%20table%20with%20chips%20and%20cards%2C%20green%20felt%20surface%2C%20golden%20poker%20chips%20stacked%2C%20dark%20elegant%20room%2C%20focused%20atmosphere%2C%20premium%20casino%20photography%2C%20rich%20warm%20tones&width=600&height=400&seq=game-09&orientation=landscape",
    rating: 4.9,
    players: "145,200",
    tag: "热门",
    tagColor: "bg-accent-500",
  },
  {
    id: 10,
    name: "深海捕鱼王",
    category: "fishing",
    image: "https://readdy.ai/api/search-image?query=Exciting%20underwater%20fishing%20arcade%20game%20with%20colorful%20exotic%20fish%2C%20animated%20bubbles%20and%20sparkles%2C%20deep%20blue%20ocean%20background%2C%20coral%20reef%20environment%2C%20gaming%20HUD%20overlay%2C%20vibrant%20colors%2C%20playful%20digital%20art%20style&width=600&height=400&seq=game-10&orientation=landscape",
    rating: 4.6,
    players: "67,300",
    tag: "新品",
    tagColor: "bg-secondary-500",
  },
  {
    id: 11,
    name: "超级大奖池",
    category: "jackpot",
    image: "https://readdy.ai/api/search-image?query=Massive%20glowing%20jackpot%20prize%20display%20with%20golden%20numbers%2C%20sparkling%20coins%20cascading%2C%20dark%20luxurious%20background%2C%20dramatic%20lighting%20effects%2C%20grand%20prize%20atmosphere%2C%20opulent%20golden%20aesthetic%2C%203D%20render%2C%20high%20detail&width=600&height=400&seq=game-11&orientation=landscape",
    rating: 4.9,
    players: "320,600",
    tag: "热门",
    tagColor: "bg-accent-500",
  },
  {
    id: 12,
    name: "骰宝争霸",
    category: "table",
    image: "https://readdy.ai/api/search-image?query=Traditional%20Sic%20Bo%20dice%20game%20table%20with%20golden%20dice%2C%20Asian-themed%20casino%20setting%2C%20red%20and%20gold%20decorations%2C%20warm%20ambient%20lighting%2C%20elegant%20gaming%20table%2C%20premium%20casino%20photography%2C%20rich%20cultural%20atmosphere&width=600&height=400&seq=game-12&orientation=landscape",
    rating: 4.7,
    players: "98,400",
    tag: "经典",
    tagColor: "bg-primary-500",
  },
];